import { AiOutlineClose } from 'react-icons/ai';
import ModalPortal from '../../../components/lib/modalPortal';
import { extractOrderItems } from '../../../utils/StringUtils';

const StatusBadge = ({ status }) => {
    const map = {
        PENDING:  { label: 'Pendente',  className: 'bg-yellow-100 text-yellow-700' },
        RELEASED: { label: 'Liberada',  className: 'bg-blue-100 text-blue-700' },
        CANCELED: { label: 'Cancelada', className: 'bg-red-100 text-red-600' },
    };
    const { label, className } = map[status] || { label: status, className: 'bg-gray-100 text-gray-600' };
    return <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${className}`}>{label}</span>;
};

const Row = ({ label, value }) => value == null ? null : (
    <div className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0">
        <span className="text-xs font-bold text-gray-400 uppercase">{label}</span>
        <span className="text-sm text-gray-700 font-medium text-right max-w-[60%]">{value}</span>
    </div>
);

export const ReservationDetailsModal = ({ reservation, isOpen, onClose, onCancel, canManage, isParent }) => {
    if (!isOpen || !reservation) return null;

    const studentName = reservation.studentId?.split(' / ')[1] || reservation.studentId;
    const formattedDate = reservation.desiredDate
        ? new Date(reservation.desiredDate + 'T00:00:00').toLocaleDateString('pt-BR')
        : '-';
    const formattedTotal = reservation.total != null
        ? `R$ ${reservation.total.toFixed(2).replace('.', ',')}`
        : '-';

    const items = extractOrderItems(reservation.itemsList);

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
                    <div className="flex justify-between items-center p-5 border-b border-slate-100">
                        <div className="flex items-center gap-3">
                            <h3 className="text-lg font-bold text-gray-800">Reserva #{reservation.reservationId}</h3>
                            <StatusBadge status={reservation.status} />
                        </div>
                        <button onClick={onClose}><AiOutlineClose className="text-gray-400" /></button>
                    </div>

                    <div className="p-5">
                        <Row label="Aluno" value={studentName} />
                        <Row label="Data" value={formattedDate} />
                        <Row label="Turno" value={reservation.turnName} />
                        <Row label="Total" value={formattedTotal} />
                        <Row label="Pagamento" value={reservation.paymentMethod} />
                        <Row label="Criada em" value={reservation.createdAt ? new Date(reservation.createdAt).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : null} />
                            {reservation.status === 'RELEASED' && reservation.releasedAt && (
                            <Row label="Liberada em" value={new Date(reservation.releasedAt).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })} />
                        )}
                        {reservation.status === 'RELEASED' && reservation.linkedOrderId && (
                            <Row label="Pedido gerado" value={`#${reservation.linkedOrderId}`} />
                        )}

                        {items.length > 0 && (
                            <div className="mt-3">
                                <span className="text-xs font-bold text-gray-400 uppercase">Itens</span>
                                <ul className="mt-1 space-y-1">
                                    {items.map((item, i) => (
                                        <li key={i} className="flex justify-between text-sm text-gray-700">
                                            <span>{item.name}</span>
                                            <span className="text-gray-400">x{item.quantity}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>

                    <div className="flex gap-3 p-5 border-t border-slate-100">
                        {reservation.status === 'PENDING' && (canManage || isParent) && (
                            <button
                                onClick={() => { onClose(); onCancel(reservation); }}
                                className="flex-1 py-3 bg-red-500 text-white rounded-lg font-bold text-sm"
                            >
                                Cancelar Reserva
                            </button>
                        )}
                        <button onClick={onClose} className="flex-1 py-3 bg-gray-100 rounded-lg font-bold text-sm text-gray-700">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};
